import * as React from 'react'
import { observer } from 'mobx-react'
import styles from '../styles.sass'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import MemberSignupView from './MemberSignupView'
import WorkspaceSearchView from './WorkspaceSearchView'
import WorkspaceSignupState from './WorkspaceSignupState'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  workspaceSignupState: WorkspaceSignupState
}

export default observer(function WorkspaceSignupContainer({
  workspaceSignupState,
}: Props) {
  return (
    <div className={styles.configurer}>
      <div className={styles.titlebar}>
        {workspaceSignupState.configurerView !== 'register' && (
          <IconButton
            onClick={() => workspaceSignupState.closeWorkspaceSearch()}
          >
            <Icon name="back" />
          </IconButton>
        )}
        <h4>
          Workspace{' '}
          {workspaceSignupState.configurerView === 'register' && 'Registration'}
          {workspaceSignupState.configurerView === 'search' && 'Search'}
        </h4>
      </div>
      {(function () {
        switch (workspaceSignupState.configurerView) {
          case 'search':
            return (
              <WorkspaceSearchView
                workspaceSignupState={workspaceSignupState}
              />
            )
          case 'register':
            return (
              <MemberSignupView workspaceSignupState={workspaceSignupState} />
            )
        }
      })()}
    </div>
  )
})
